// extracted by mini-css-extract-plugin
export default {"dissolutionGrid":"members-dissolution_dissolutionGrid__U7Hi0","dissolutionPuck":"members-dissolution_dissolutionPuck__HRlWs"};